import { render, staticRenderFns } from "./PricingSkipAndAccept.vue?vue&type=template&id=1545d2ec&"
import script from "./PricingSkipAndAccept.vue?vue&type=script&lang=js&"
export * from "./PricingSkipAndAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports